/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

export * from '@api/v1/requests/auth';
export * from '@api/v1/requests/share';
export * from '@api/v1/requests/user-app';
export * from '@api/v1/requests/tenant-app';

export const batchRequest = async (
  requests: Array<Promise<any>>,
): Promise<any[]> => axios.all(requests);
